import type { Router } from 'vue-router'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { clearPasswordLink } from '@/utils/passwordLinkFragment'

/**
 * Forgets a captured set-password link as soon as the app lands anywhere else, so a token that
 * a redirect left behind cannot outlive its page in module memory (vue-vxapp#364).
 */
export const installPasswordLinkCleanup = (router: Pick<Router, 'afterEach'>): void => {
  router.afterEach(to => {
    if (to.name !== PageMeta.Auth.setPassword.name) clearPasswordLink()
  })
}
